<template>
	<div class="field share-slider">
		<label class="label mb-2" for="cam-share-slider">
			How much work could you hand to Cam?
		</label>

		<input
			id="cam-share-slider"
			type="range"
			min="0"
			max="100"
			step="5"
			:value="sharePercent"
			:style="{ '--range-fill': `${sharePercent}%` }"
			:aria-valuetext="`${sharePercent}%`"
			@input="onInput"
		/>

		<div class="is-flex is-justify-content-space-between is-size-7 has-text-grey mt-1">
			<span>A few small tickets</span>
			<span>Most of your backlog</span>
		</div>
	</div>
</template>

<script>

export default {
	computed: {
		sharePercent() {
			return Math.round(this.$store.share * 100);
		},
	},

	methods: {
		onInput(event) {
			this.$store.share = Number(event.target.value) / 100;
		},
	},
};

</script>
